<div class="d-flex gap-3 container-box shadow-none">
  <div class="flex-fill text-center py-5">
    <div class="w-50 m-auto">
      <img src="/assets/images/channel-wizards/complete-icon.webp" alt="" height="50" />
      <h6 class="mt-2" i18n>Congratulations!</h6>
      <p i18n>
        Great! You’re now ready to review your Booking.com connection with AdvanceCM. You’ll be taken to the Booking.com
        channel details screen, where you can review each of your listing connections with AdvanceCM.
      </p>
      <div class="d-flex gap-3 align-items-center justify-content-center mt-4">
        <button class="btn btn-secondary-info" (click)="reset.emit()">
          <i class="far fa-link"></i> <ng-container i18n>Connect another account</ng-container>
        </button>
        <button class="btn btn-secondary-primary" (click)="channel.emit()">
          <i class="cs-icon cs-icon-list-square"></i> <ng-container i18n>Channel Details</ng-container>
        </button>
      </div>
    </div>
  </div>
  <div class="px-3 py-4 m-4 text-center" style="background: #f2f2f2; width: 0; min-width: 350px">
    <img src="/assets/images/channel-wizards/hands-clap.webp" alt="" class="mb-4" />
    <h5 i18n>Connection request completed</h5>
    <p i18n>
      Your Booking.com property<ng-container *ngIf="propertyId"> {{ propertyId }}</ng-container> is now connected to
      AdvanceCM. Linked rentals will show as Active after the first successful availability and rate sync.
    </p>
    <ul class="list-group my-4 text-left text-sm rounded-0">
      <li class="list-group-item">
        <div class="text-semi-bold" i18n>Summary of your request</div>
      </li>
      <li class="list-group-item" i18n>AdvanceCM is the connectivity provider handling your connection.</li>
      <li class="list-group-item" i18n>
        The requested type of connection: Reservations, Rates & Availability, Guest Reviews, Guest Messages, Performance
        data and insights, Reporting
      </li>
      <li class="list-group-item" i18n>
        You can review this connection anytime in the Booking.com extranet under Account &gt; Connectivity provider.
      </li>
    </ul>

    <a
      href="https://admin.booking.com/"
      target="_blank"
      rel="noopener"
      class="btn text-white"
      style="background: #0171c2"
      i18n
      >Go to the Booking.com Extranet</a
    >
  </div>
</div>
<div class="mt-3 d-flex align-items-center gap-3">
  <button class="btn btn-outline-light" (click)="prev.emit()">
    <i class="cs-icon cs-icon-arrow-left-long text-xxs"></i>
    <ng-container i18n>Previous</ng-container>
  </button>
  <div class="flex-1"></div>
  <button class="btn btn-secondary-info" (click)="done.emit()">
    <i class="cs-icon cs-icon-tasks"></i>
    <ng-container i18n>Done</ng-container>
  </button>
</div>
